import React, { useState, useEffect, createContext, useContext } from 'react'
import { cn } from '@/utils/cn'

const TabsContext = createContext({ activeTab: undefined, setActiveTab: () => {} })

export function Tabs({ value: controlledValue, defaultValue, children, className = '', onValueChange }) {
  const [activeTab, setActiveTabState] = useState(defaultValue)

  // Support controlled usage
  useEffect(() => {
    if (controlledValue !== undefined) {
      setActiveTabState(controlledValue)
    }
  }, [controlledValue])

  const setActiveTab = (val) => {
    if (controlledValue === undefined) {
      setActiveTabState(val)
    }
    onValueChange?.(val)
  }

  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab }}>
      <div className={cn('w-full', className)}>{children}</div>
    </TabsContext.Provider>
  )
}

export function TabsList({ children, className = '' }) {
  return (
    <div className={cn('inline-flex h-10 items-center justify-center rounded-xl bg-muted p-1 text-muted-foreground', className)}>
      {children}
    </div>
  )
}

export function TabsTrigger({ children, value, className = '' }) {
  const { activeTab, setActiveTab } = useContext(TabsContext)
  const isActive = activeTab === value

  return (
    <button
      className={cn(
        'inline-flex items-center justify-center whitespace-nowrap rounded-lg px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
        isActive ? 'bg-background text-foreground shadow-sm' : 'hover:bg-background/50',
        className
      )}
      onClick={() => setActiveTab(value)}
      type="button"
    >
      {children}
    </button>
  )
}

export function TabsContent({ children, value, className = '' }) {
  const { activeTab } = useContext(TabsContext)
  if (activeTab !== value) return null

  return (
    <div className={cn('mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2', className)}>
      {children}
    </div>
  )
}